// tour guide
export const TOUR_GUIDE_OPTIONS = {
    arrowColor: "#EEE",
    backgroundColor: "#EEE",
    primaryColor: "#42A5F5",
    textColor: "#333",
    width: "350px",
    zIndex: 99999
}